export default function SortedAbundanceFromRank({ subSampleTaxaData, rank, top }) {
    // console.log(subSampleTaxaData)

    const processedData = Object.entries(subSampleTaxaData).map(([sampleId, sampleTaxaData]) => {
        // const filteredByRank = sampleTaxaData.filter(item => item.rank === rank);
        const filteredByRank = sampleTaxaData.filter(item => item.taxon.rank === rank);
        // console.log(filteredByRank)

        // const totalCount = sampleTaxaData.reduce((acc, item) => acc + item.count, 0);
        const totalCount = filteredByRank.reduce((acc, item) => acc + item.count, 0);
        // console.log(totalCount)
        // console.log(totalCount)
        const taxaWithAbundance = filteredByRank.map(item => ({
            name: item.taxon.name,
            abundance: item.count / totalCount
        }));

        // const sortedTaxa = taxaWithAbundance.sort((a, b) => b.abundance - a.abundance);

        return { sampleId, taxaWithAbundance }
    });
    // console.log(processedData)

    const allOrganisms = processedData.flatMap(sample => sample.taxaWithAbundance.map(taxa => taxa.name));
    // console.log("processedData: ", processedData);

    const organismSet = new Set(allOrganisms);
    const intersectionOrganisms = Array.from(organismSet).filter(organism =>
        processedData.every(sample => sample.taxaWithAbundance.some(taxa => taxa.name === organism))
    );
    console.log(intersectionOrganisms)

    const organismSums = intersectionOrganisms.map(organism => {
        const sum = processedData.reduce((acc, sample) => {
            const taxa = sample.taxaWithAbundance.find(taxa => taxa.name === organism);
            return acc + (taxa ? taxa.abundance : 0);
        }, 0);
        return { name: organism, sumAbundance: sum };
    });

    const topOrganisms = organismSums
        .sort((a, b) => b.sumAbundance - a.sumAbundance)
        .slice(0, top);

    // this data could be used to create a stacked barplot:
    // console.log(topOrganisms)
    // console.log(topOrganisms)
    // use the order of topOrganisms to sort all samples in processedData

    const sortedSamples = processedData.map(sample => {
        const sortedTaxa = topOrganisms.map(organism => {
            const taxa = sample.taxaWithAbundance.find(taxa => taxa.name === organism.name);
            return { name: organism.name, abundance: taxa ? taxa.abundance : 0 };
        });
        return { sampleId: sample.sampleId, sortedTaxa };
    });
    // console.log(sortedSamples)
    // return sortedSamples;
    return sortedSamples;

}